import { Box } from "@mui/material";
import { Carousel } from "@atoms/Carousel";
import { Section } from "@atoms/Section";
import FAQ from "@containers/FAQ";
import SearchBox from "@ds/components/SearchBox";
import Text from "@ds/components/Text";
import useActions from "../../hooks/useActions";
import type { IPropsGetSupport } from "../../interface";
import useStyles from "../../styles";
import HeaderSupport from "@containers/Profile/lib/MobilePwa/Partials/AccountPartials/HeaderSupport";
import { useState, useEffect } from "react";
import { fontFamSecondary } from "@definitions/mui/custom";
import { TopicBack } from "@icons/mobile";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

const Mobile: React.FC<IPropsGetSupport> = ({ isMobile, dataFaq, topic }) => {
  const router = useRouter();
  const [searchIconShown, setSearchIconShown] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useTranslation("faq");
  const { search, handleSearch, dataVariants } = useActions(topic);
  const classes = useStyles({ search, isMobile });

  useEffect(() => {
    window.onscroll = function () {
      if (window.scrollY > 358) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  }, []);

  const renderSearchBox = () => (
    <Box
      sx={{
        input: {
          fontSize: 14,
          fontFamily: fontFamSecondary,
        },
      }}
    >
      <SearchBox
        onChange={handleSearch}
        value={search}
        placeholder={t("placeholder")}
        css={{
          backgroundColor: "#FDFDFD",
          border: "1px solid #DEE3ED",
          height: "48px",
        }}
      />
    </Box>
  );

  const renderMobileBanner = () => (
    <Box className={classes.bannerBody} gap={3}>
      <Box width="100%" margin="auto" textAlign="center">
        <Box height="48px" display="flex" alignItems="center">
          <TopicBack
            style={{
              cursor: "pointer",
            }}
            onClick={() => router.push(topic ? "/bantuan" : "/profile")}
          />
        </Box>
        <Text weight="700" variant="h1" color="white" sx={{ lineHeight: "39px" }}>
          {t("title")}
        </Text>
        <Text
          weight="600"
          variant="body2"
          color="white"
          component="p"
          sx={{
            marginTop: 8,
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: "328px",
            lineHeight: "19px",
          }}
        >
          {t("subtitle")}
        </Text>
      </Box>
      <Box
        className={classes.carousel}
        sx={{
          ".slick-dots": {
            bottom: -36,
            "& li": {
              margin: "0 6px",
            },
          },
          ".slick-dots li.slick-active button:before": {
            backgroundColor: "#FDFDFD !important",
            fontSize: 0,
            opacity: 1,
          },
          ".slick-dots li button:before": {
            fontSize: 0,
          },
        }}
      >
        <Carousel settings={{ slidesToShow: 1, dots: true }} arrows={false}>
          {dataVariants.map(
            (el: { title: string; subTitle: string; icon: string }, idx: number) => (
              <Box key={idx}>
                <Box className={classes.variantSectionMobile}>
                  <Box
                    mb="16px"
                    sx={{
                      lineHeight: 1,
                    }}
                  >
                    <Box component="img" src={el.icon} alt="icon-img" width="40px" height="40px" />
                  </Box>
                  <Box>
                    <Text
                      weight="600"
                      variant="h3"
                      color="white"
                      sx={{ fontSize: "14px", lineHeight: "17px" }}
                    >
                      <strong>{el.title}</strong> {el.subTitle}
                    </Text>
                  </Box>
                </Box>
              </Box>
            ),
          )}
        </Carousel>
      </Box>
    </Box>
  );

  const HeaderGetSupport = (
    <HeaderSupport
      title={topic || t("support")}
      backPath={topic ? "/bantuan" : "/profile"}
      withSearchIcon={!!topic}
      searchIconShown={searchIconShown}
      onClickSearchIcon={() => setSearchIconShown(false)}
    />
  );

  return (
    <>
      {topic === "" ? <>{scrolled && HeaderGetSupport}</> : HeaderGetSupport}
      <Box bgcolor="#FFF" position="relative" height={isMobile ? "100vh" : undefined}>
        {!topic && (
          <Section className={classes.sectionHeader} pt={isMobile ? 0 : undefined}>
            {renderMobileBanner()}
            <Box mt={search && !isMobile ? -4 : "46px"} width="100%">
              {renderSearchBox()}
            </Box>
          </Section>
        )}
        <Section
          paddingTop={!topic ? "24px" : 3}
          paddingBottom={isMobile ? "32px" : undefined}
          mt={topic === "" ? "333px" : 0}
          bgcolor="white"
          position="relative"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <FAQ dataFaq={dataFaq} isGetSupport={true} searchIconShown={searchIconShown} />
        </Section>
      </Box>
    </>
  );
};

export default Mobile;
